export default "__VITE_ASSET__BgLF6aW4__"